<template>
  <sc-page-base title="Logs de erro CT-e">
    <sc-table
      :loading="loadingLogList"
      :data="cteLogList"
      :total="cteLogListTotal"
      :per-page="pagination.size"
      :current-page="pagination.page"
      :paginated="true"
      :backend-pagination="true"
      @page-change="(newPage) => pagination.page = newPage">

      <template slot-scope="{ row }">
        <sc-table-column label="Nome do arquivo" field="filename">
          {{ row.filename }}
        </sc-table-column>

        <sc-table-column label="CT-e" field="cte_identifier">
          {{ row.cte_identifier }}
        </sc-table-column>

        <sc-table-column label="Transportadora" field="logistic_provider_id">
          {{ getLogisticProviderName(row.logistic_provider_id) }}
        </sc-table-column>

        <sc-table-column label="Data de processamento" field="processing_date_time">
          {{ row.processing_date_time | date("DD/MM/YYYY") }} às
          {{ row.processing_date_time | date("HH:mm") }}
        </sc-table-column>

        <sc-table-column label="Forma de envio" field="file_source">
          {{ row.file_source }}
        </sc-table-column>

        <sc-table-column label="Motivo do erro" field="processing_description">
          {{ row.processing_description }}
        </sc-table-column>
      </template>

      <template slot="footer">
        <p v-if="cteLogListTotal">
          <strong>Total de registros:</strong>
          <span>{{ cteLogListTotal }}</span>
        </p>
      </template>

      <template slot="bottom-left">
        <sc-table-per-page v-model="pagination.size" />
      </template>

      <template slot="empty">
        <sc-table-empty />
      </template>
    </sc-table>
  </sc-page-base>
</template>
<script>
import {
  ScPageBase,
  ScIcon,
  ScTable,
  ScTableColumn,
  ScTableEmpty,
  ScTablePerPage,
} from '@intelipost-js/secure-components';

import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions, mapMutations } = createNamespacedHelpers('recon/cteLogs');

export default {
  name: 'cte-logs',
  data() {
    return {
      pagination: {
        page: 1,
        size: 10,
      },
    };
  },
  methods: {
    ...mapActions(['getLogList']),
    ...mapMutations(['setLoadingLogList']),
    getLogisticProviderName(logisticProviderId) {
      return this.$store.getters['logisticProviders/logisticProviderName'](logisticProviderId);
    },
  },
  computed: {
    ...mapState(['cteLogList', 'cteLogListTotal', 'loadingLogList']),
    currentPage() {
      return this.pagination.page;
    },
    currentSize() {
      return this.pagination.size;
    },
  },
  watch: {
    currentPage() {
      this.getLogList({ ...this.pagination });
    },
    currentSize() {
      this.getLogList({ ...this.pagination });
    },
  },
  async beforeMount() {
    this.setLoadingLogList(true);
    await this.$store.dispatch('logisticProviders/getLogisticProviders');
    this.getLogList({ ...this.pagination });
  },
  components: {
    ScPageBase,
    ScIcon,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScTablePerPage,
  },
};

</script>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/cte-logs/PageCTeLogs.vue